import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Menu from '../../components/menu/Menu';
import NavBar from '../../components/navbar/NavBar';
import Select from 'react-select';
import './TelaRelatorio.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchCategories } from '../../services/api/fetchCategories';
import RelatorioAnalitico from '../../components/Reports/AnaliticoTemplate/RelatorioAnalitico';
import ReactLoading from 'react-loading';
import { FaDownload } from 'react-icons/fa';
import ConfirmModal from '../../components/confirmModal/confirmModal';
// import { fetchReportClear } from '../../services/api/fetchReport';
import { fetchSubjects } from '../../services/api/fetchGrouper';
import ReportStatistic from '../../components/Reports/AnaliticoTemplate/ReportStatistic/ReportStatistic';
import { fetchDashboard } from '../../services/api/fetchDashboard';
import { AnalyticalMessage } from '../../services/api/fetchAnalyticalMessage';
import { PostAnalyticalReportData } from '../../services/api/fetchAnalyticalReportData';
import { getAnalyticalReportDataDetails } from '../../services/api/fetchAnalyticalReportData';
import RelatorioStatusCard from '../../components/RelatorioStatusCard/RelatorioStatusCard';
import { patchAnalyticalReportData } from '../../services/api/fetchAnalyticalReportData';

const TelaRelatorio = () => {
    const [selectedReport, setSelectedReport] = useState(null);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [dateRangeStatistical, setDateRangeStatistical] = useState([null, null]);
    const [startDateStatistical, endDateStatistical] = dateRangeStatistical;
    const [statisticalReportData, setStatisticalReportData] = useState(null);
    const [reportData, setReportData] = useState(null);
    const { clientId } = useParams();
    const relatorioAnaliticoRef = useRef();
    const [isLoadingGenerate, setIsLoadingGenerate] = useState(false);
    const [isLoadingPDF, setIsLoadingPDF] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [downloadSuccessMessage, setDownloadSuccessMessage] = useState('');
    const [isMenuExpanded, setIsMenuExpanded] = useState(false);
    const [selectedPages, setSelectedPages] = useState([]); 
    const linkClient = process.env.REACT_APP_CLIENT_URL;
    // const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [swot, setSwot] = useState([]);
    const [selectedSwot, setSelectedSwot] = useState(null); 
    const [qualitative, setQualitative] = useState([]);
    const [selectedQualitative, setSelectedQualitative] = useState(null); 
    const [mention, setMention] = useState([]);
    const [selectedMention, setSelectedMention] = useState(null);
    const [comments, setComments] = useState({});
    const [reportId, setReportId] = useState(null)
    const [shouldShowReport, setShouldShowReport] = useState(false);
    const [pdfName, setPdfName] = useState('');
    const [isSavingPDF, setIsSavingPDF] = useState(false);

    const pageOptions = [
        { value: 'all', label: 'Todos' },
        { value: 'sumary', label: 'Resumo' },
        { value: 'qualitativeAnalysis', label: 'Análise qualitativa das matérias' },
        { value: 'textType', label: 'Notícias por tipo de texto' },
        { value: 'directIndirect', label: 'Direta/Indireta' },
        { value: 'releaseMention', label: 'Origem da Pauta' },
        { value: 'topicWordCloud', label: 'Nuvem de Assuntos' },
        { value: 'mediaDistribution', label: 'Distribuição por mídia' },
        { value: 'occupiedSpace', label: 'Espaço ocupado na mídia' },
        { value: 'qualitativeSpace', label: 'Análise qualitativa do espaço' },
        { value: 'categoriesTotal', label: 'Total por Categoria' },
        { value: 'categoriesQualitative', label: 'Análise Qualitativa por Categoria' },
        { value: 'mediaNews', label: 'Notícias por veículo' },
        { value: 'mediaValue', label: 'Valoração por veículo' },
        { value: 'top10SourcesClippingValuation', label: 'Top 10 Valoração Por Veículo' },
        { value: 'publishDate', label: 'Notícias por data de publicação' },
        { value: 'statesNews', label: 'Notícias por estado' },
        { value: 'swot', label: 'Análise SWOT' },
        { value: 'audienceAnalysis', label: 'Audiência' },
        { value: 'totalMedia', label: 'Total Mídias' },
        { value: 'vehicles', label: 'Veículos' },
        { value: 'vehicles-tv', label: 'Veículos TV' },
        { value: 'vehicles-radio', label: 'Veículos Rádio' },
        { value: 'vehicles-impresso', label: 'Veículos Impresso' },
        { value: 'vehicles-web', label: 'Veículos Web' },
        { value: 'categories', label: 'Categorias' },
        { value: 'tagsQualitative', label: 'Tabela de Assuntos' },
        { value: 'Final', label: 'Conclusão' },
    ];

    useEffect(() => {
        setReportData(null);
        setStatisticalReportData(null);
    
        setDateRange([null, null]);
        setDateRangeStatistical([null, null]);
        setSelectedCategory(null);
        setSelectedPages([]);
        setKeyword("");
        setSelectedSubject(null);
        setSelectedSwot(null);
        setSelectedQualitative(null);
        setSelectedMention(null);
    
    }, [selectedReport]);

useEffect(() => {
    if (selectedReport?.value === 1) {
        setSelectedPages(pageOptions.filter(p => p.value !== 'all'));
    }
}, [selectedReport]);
    

    useEffect(() => {
        if (selectedReport && selectedReport.value === 1) {
            fetchCategories(clientId).then(data => {
                const categoryOptions = data.map(category => ({
                    value: category.id,
                    label: category.name
                }));
                setCategories(categoryOptions);
            }).catch(error => {
                console.error('Erro ao carregar categorias:', error);
            });
        }
    }, [selectedReport, clientId]);

    useEffect(() => {
        const fetchSubjectsAndSwotData = async () => {
            try {
                const data = await fetchSubjects(clientId);
                const subjectOptions = data.subjects.map(subject => ({
                    value: subject,
                    label: subject,
                }));
                const swotOptions = data.swot.map(swotItem => ({
                    value: swotItem,
                    label: swotItem,
                }));
                const QualitativeOptions = data.qualitative.map(qualitativeItem => ({
                    value: qualitativeItem,
                    label: qualitativeItem,
                }));
                const MentionOptions = data.mention.map(mentionItem => ({
                    value: mentionItem,
                    label: mentionItem,
                }));
    
                setSubjects(subjectOptions);
                setSwot(swotOptions);
                setQualitative(QualitativeOptions);
                setMention(MentionOptions);
            } catch (error) {
                console.error('Erro ao carregar dados de Assunto e SWOT:', error);
            }
        };
    
        fetchSubjectsAndSwotData();
    }, [clientId]);

    const Reports = [
        {id: 1, name: "Relatório de Análise Crítica"},
        { id: 2, name: "Relatório Estatístico" }
    ]

    const reportOptions = Reports.map(report => ({ value: report.id, label: report.name }));

    const clearMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
        setDownloadSuccessMessage('');
    };

    const handleGenerateReport = async () => {
        clearMessages();
        setReportData(null);

        if (!startDate || !endDate) {
            setErrorMessage('Por favor, selecione um intervalo de datas.');
            setTimeout(() => {
                clearMessages();
            }, 5000);
            return; 
        }

        resetReportState();
        setIsLoadingPDF(true);

        const categoryIds = selectedCategory?.length > 0 ? selectedCategory.map(c => c.value) : [];
        const subject = selectedSubject ? selectedSubject.value : '';
        const swot = selectedSwot ? selectedSwot.value : '';
        const qualitative = selectedQualitative ? selectedQualitative.value : '';
        const mention = selectedMention ? selectedMention.value : '';
        const Validationkeyword = keyword.length > 0 ? keyword : '';

        try {
            const result = await PostAnalyticalReportData(
                clientId,
                startDate,
                endDate,
                categoryIds,
                Validationkeyword,
                subject,
                swot,
                qualitative,
                mention
            );
            console.log('Resposta da API:', result);

            setReportId(result.id);

            if (!result?.id) {
                throw new Error('Resposta da API não contém ID');
            }

            const details = await getAnalyticalReportDataDetails(result.id);

            if (details.count === 0 || details.total === 0) {
                setErrorMessage('Não há notícias avaliadas para o período selecionado.');
            } else {
                setReportData(details.results);
                setSuccessMessage('Relatório gerado com sucesso!');
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Erro ao gerar relatório. Verifique os dados ou tente novamente.');
        } finally {
            setIsLoadingPDF(false);
            setTimeout(() => {
                clearMessages();
            }, 5000);
        }
    };

    const handleDownloadReport = async () => {
        setIsLoadingPDF(true); // Ativa o loading no botão de download
        try {
            if (relatorioAnaliticoRef.current) {
                await relatorioAnaliticoRef.current.handlePrint();
                setDownloadSuccessMessage('Relatório exportado com sucesso!');
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Erro ao fazer o download do relatório.');
        } finally {
            setIsLoadingPDF(false); // Desativa o loading
        }

        // Limpa mensagens após 5 segundos
        setTimeout(() => {
            clearMessages();
        }, 3000);
    };

const handlePageSelection = (selected) => {
    if (selected.some(option => option.value === 'all')) {
        setSelectedPages(pageOptions.filter(option => option.value !== 'all'));
    } else {
        setSelectedPages(selected);
    }
};

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            maxWidth: '600px',
            padding: '10px',
            fontSize: '14px',
            borderColor: state.isFocused ? '#ccc' : '#ccc',
            borderRadius: '4px',
            backgroundColor: 'white',
            color: '#333',
            outline: 'none',
            boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none',
            transition: 'border-color 0.3s, box-shadow 0.3s',
            '&:hover': {
                borderColor: '#ccc',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            maxWidth: '600px',
            backgroundColor: state.isFocused ? '#eee' : '#fff',
            color: '#333',
            padding: '10px',
            '&:active': {
                backgroundColor: '#eee',
            },
        }),
        menu: (provided) => ({
            ...provided,
            maxWidth: '600px',
            zIndex: 2,
        }),
    };

    const customStylesPages = {
        control: (provided, state) => ({
            ...provided,
            maxWidth: '100%',
            padding: '10px',
            fontSize: '14px',
            borderColor: state.isFocused ? '#ccc' : '#ccc',
            borderRadius: '4px',
            backgroundColor: 'white',
            color: '#333',
            outline: 'none',
            boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none',
            transition: 'border-color 0.3s, box-shadow 0.3s',
            '&:hover': {
                borderColor: '#ccc',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            maxWidth: '100%',
            backgroundColor: state.isFocused ? '#eee' : '#fff',
            color: '#333',
            padding: '10px',
            '&:active': {
                backgroundColor: '#eee',
            },
        }),
        menu: (provided) => ({
            ...provided,
            maxWidth: '100%',
            zIndex: 2,
        }),
    };

    // const handleGenerateReportWithClear = () => {
    //     clearMessages();
    //     setReportData(null);
    
    //     // const selectedCategories = selectedCategory || [];
    //     const categoryId = selectedCategory ? selectedCategory.value : null;
    //     const subject = selectedSubject ? selectedSubject.value : null;
    //     const swot = selectedSwot ? selectedSwot.value : null;
    //     const qualitative = selectedQualitative ? selectedQualitative.value : null;
    //     const mention = selectedMention ? selectedMention.value : null;
    //     const Validationkeyword = keyword.length > 0 ? keyword : null;
    
    //     setIsLoadingPDF(true);
    
    //     fetchReportClear(clientId, startDate, endDate, categoryId, true, Validationkeyword, subject, swot, qualitative, mention)
    //         .then(response => {
    //             if (response.processed === false) {
    //                 setSuccessMessage('Relatório sendo processado. Tente novamente em alguns minutos.');
    //             } else if (response.count === 0 || response.total === 0) {
    //                 setErrorMessage('Não há notícias avaliadas para o período selecionado.');
    //             } else {
    //                 setReportData(response);
    //                 setSuccessMessage('Relatório gerado com sucesso após limpeza dos dados!');
    //             }
    //         })
    //         .catch(error => {
    //             console.error(error);
    //             setErrorMessage('Erro ao gerar relatório com limpeza dos dados.');
    //         })
    //         .finally(() => {
    //             setIsLoadingPDF(false);
    //         });
    
    //     setTimeout(() => {
    //         clearMessages();
    //     }, 5000);
    // };

    // const handleConfirmClearReport = () => {
    //     setShowConfirmModal(false);
    //     handleGenerateReportWithClear();
    // };


    const handleToggleMenu = (expanded) => {
        setIsMenuExpanded(expanded);
      };

      const handleGenerateStatisticalReport = async () => {
        if (!startDateStatistical || !endDateStatistical) {
            setErrorMessage("Por favor, selecione um intervalo de datas.");

            setTimeout(() => {
                clearMessages();
            }, 5000);
            return;
        }
    
        setIsLoadingPDF(true);
        setErrorMessage("");
        setSuccessMessage("");
    
        try {
            const response = await fetchDashboard(
                startDateStatistical.toLocaleDateString("pt-BR"),
                endDateStatistical.toLocaleDateString("pt-BR"),
                clientId
            );
    
            setStatisticalReportData(response);
            setSuccessMessage("Relatório estatístico gerado com sucesso!");
            setTimeout(() => {
                clearMessages();
            }, 5000);
        } catch (error) {
            console.error("Erro ao carregar os dados do relatório:", error);
            setErrorMessage("Erro ao carregar os dados.");
            setTimeout(() => {
                clearMessages();
            }, 5000);
        } finally {
            setIsLoadingPDF(false);
        }
    };

    const fetchAndSetComments = async () => {
        try {
            const messages = await AnalyticalMessage(clientId);
            
            const storedComments = {};
            const submittedStatus = {};
    
            messages.forEach(msg => {
                storedComments[msg.page] = msg.message;
                submittedStatus[msg.page] = true;
            });
    
            setComments(storedComments);
    
        } catch (error) {
            console.error("Erro ao carregar mensagens:", error);
        }
    };

    const handleButtonClick = () => {
        resetReportState();
        handleGenerateReport();
        fetchAndSetComments();
    };

    const handleVisualizarRelatorio = async (id) => {
        try {
            const response = await getAnalyticalReportDataDetails(id);
            if (response?.results) {
            setReportData(response.results);
            setSelectedPages([]);
            setSuccessMessage("Relatório carregado com sucesso!");
            setShouldShowReport(true);
            setTimeout(() => setSuccessMessage(''), 5000);
            }
        } catch (error) {
            console.error('Erro ao carregar relatório analítico:', error);
            setErrorMessage("Erro ao carregar relatório analítico.");
            setTimeout(() => setSuccessMessage(''), 5000);
        }
    };

const handleSavePDF = async () => {
    if (!relatorioAnaliticoRef.current || !pdfName || !reportId) return;

    try {
        setIsSavingPDF(true);
        setIsLoadingPDF(true); // <- Esconde controles da capa

        // Gera o PDF e retorna como Blob
        const pdfBlob = await relatorioAnaliticoRef.current.generatePDFBlob();

        if (!pdfBlob) throw new Error("PDF não foi gerado corretamente");

        // Envia via PATCH
        await patchAnalyticalReportData(reportId, pdfName, pdfBlob);

        setSuccessMessage('PDF salvo com sucesso!');
    } catch (error) {
        console.error("Erro ao salvar PDF:", error);
        setErrorMessage('Erro ao salvar PDF. Tente novamente.');
    } finally {
        setIsSavingPDF(false);
        setIsLoadingPDF(false);
        setTimeout(() => clearMessages(), 5000);
    }
};

const resetReportState = () => {
    setReportData(null);
    setReportId(null);
    setShouldShowReport(false);
    setPdfName('');
    setSelectedPages([]);
    setComments({});
    clearMessages();
};
    
    
    return (
        <div className={`container-tela-relatorio ${isMenuExpanded ? 'menu-expanded' : 'menu-collapsed'}`}>
            <div className="menu-tela-relatorio">
                <Menu onToggleMenu={handleToggleMenu} />
            </div>
            <div className="navbar-tela-relatorio">
                <NavBar />
            </div>

            <div className="main-tela-relatorio">
                <div className="row-tela-relatorio">
                    <div className="filter-tela-relatorio">
                        <div className="filter-label-relatorio">Relatório</div>
                        <Select
                            className="filter-select-relatorio"
                            styles={customStyles}
                            placeholder="Selecione um relatório"
                            value={selectedReport}
                            onChange={setSelectedReport}
                            options={reportOptions}
                        />
                    </div>
                    {selectedReport && selectedReport.value === 1 && (
                        <>


                            <div className="filter-tela-relatorio">
                                <div className="filter-label-relatorio">Categoria</div>
                                <Select
                                    className="filter-select-relatorio"
                                    styles={customStyles}
                                    placeholder="Selecione as categorias"
                                    value={selectedCategory}
                                    onChange={setSelectedCategory}
                                    options={categories}
                                    isMulti
                                />
                            </div>
                            <div className="date-picker-tela-relatorio">
                                <div className="date-picker-label-tela-relatorio">Datas</div>
                                <div className="date-picker-header-tela-relatorio">
                                    <div className="date-picker-content-tela-relatorio">
                                        <DatePicker
                                            selectsRange
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            dateFormat="dd/MM/yyyy"
                                            className="selected-date-input"
                                            placeholderText='DD/MM/AAAA - DD/MM/AAAA'
                                        />
                                    </div>
                                    <img
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/6c6cd33072230ae936f1e816d9aa1ba45453ba4d5a4f9099598c1801929589e2?apiKey=c7cb0dec5bf7436eb48ab9b2fb417d9d&"
                                        alt=""
                                        className="calendar-icon-tela-relatorio"
                                        onClick={() => document.getElementsByClassName('selected-date-input')[0].click()}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className="row-tela-relatorio">
                    {selectedReport && selectedReport.value === 1 && (
                        <>
                        <div className="filter-tela-relatorio">
                            <div className="filter-label-relatorio">Palavra-chave</div>
                            <input
                                type="text"
                                className="filter-select-relatorio keyword-dropdown"
                                placeholder="Digite a palavra-chave"
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                            />
                        </div>
                        <div className="filter-tela-relatorio">
                            <div className="filter-label-relatorio">Assunto</div>
                            <Select
                                className="filter-select-relatorio"
                                styles={customStyles}
                                placeholder="Selecione um assunto"
                                value={selectedSubject}
                                onChange={setSelectedSubject}
                                options={subjects}
                            />
                        </div>
                        {swot && swot.length > 0 && (
                            <div className="filter-tela-relatorio">
                                <div className="filter-label-relatorio">Fator Swot</div>
                                <Select
                                    className="filter-select-relatorio"
                                    styles={customStyles}
                                    placeholder="Selecione um item"
                                    value={selectedSwot}
                                    onChange={setSelectedSwot}
                                    options={swot}
                                />
                            </div>
                        )}
                        <div className="filter-tela-relatorio">
                            <div className="filter-label-relatorio">Análise qualitativa</div>
                            <Select
                                className="filter-select-relatorio"
                                styles={customStyles}
                                placeholder="Selecione um item"
                                value={selectedQualitative}
                                onChange={setSelectedQualitative}
                                options={qualitative}
                            />
                        </div>
                        <div className="filter-tela-relatorio">
                            <div className="filter-label-relatorio">Direta/Indireta</div>
                            <Select
                                className="filter-select-relatorio"
                                styles={customStyles}
                                placeholder="Selecione um item"
                                value={selectedMention}
                                onChange={setSelectedMention}
                                options={mention}
                            />
                        </div>
                        </>
                    )}
                </div>

                {/* <div className="row-tela-relatorio">
                {selectedReport && selectedReport.value === 1 && (
                        <>
                        <div className="filter-tela-relatorio">
                            <div className="filter-label-relatorio">Paginas</div>
                                <Select
                                    className="filter-select-relatorio"
                                    styles={customStylesPages}
                                    placeholder="Selecione as páginas"
                                    isMulti
                                    value={selectedPages}
                                    onChange={handlePageSelection}
                                    options={pageOptions}
                                />
                            </div>
                        </>
                    )}
                </div> */}

                {selectedReport && selectedReport.value === 1 && (
                <div className="generate-report-button-container">
                    {/* <button
                        onClick={() => setShowConfirmModal(true)}
                        disabled={isLoadingGenerate}
                        className='buttonClearCache'
                    >
                        Limpar e Gerar
                    </button> */}
                    <button onClick={handleButtonClick} disabled={isLoadingGenerate} className='buttonGenerateReport'>
                        {isLoadingGenerate ? <ReactLoading type={'spin'} color={'#ffffff'} height={30} width={30} /> : 'Gerar'}
                    </button>
                </div>
                )}


                {selectedReport && selectedReport.value === 2 && (
                    <>
                            <div className="date-picker-tela-relatorio-estatistico">
                                <div className="date-picker-label-tela-relatorio">Datas</div>
                                <div className="date-picker-header-tela-relatorio">
                                    <div className="date-picker-content-tela-relatorio">
                                        <DatePicker
                                            selectsRange
                                            startDate={startDateStatistical}
                                            endDate={endDateStatistical}
                                            onChange={(update) => {
                                                setDateRangeStatistical(update);
                                            }}
                                            dateFormat="dd/MM/yyyy"
                                            className="selected-date-input"
                                            placeholderText='DD/MM/AAAA - DD/MM/AAAA'
                                        />
                                    </div>
                                    <img
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/6c6cd33072230ae936f1e816d9aa1ba45453ba4d5a4f9099598c1801929589e2?apiKey=c7cb0dec5bf7436eb48ab9b2fb417d9d&"
                                        alt=""
                                        className="calendar-icon-tela-relatorio"
                                        onClick={() => document.getElementsByClassName('selected-date-input')[0].click()}
                                    />
                                </div>
                            </div>

                        <div className="generate-report-button-container-statistic">
                            <button 
                                onClick={handleGenerateStatisticalReport} 
                                className="buttonGenerateReport"
                            >
                                Gerar
                            </button>
                        </div>
                    </>
                )}


                {isLoadingPDF && (
                    <div className="loading-overlay active">
                        <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
                    </div>
                )}

                {successMessage && (
                    <div className="success-message">
                        <p>{successMessage}</p>
                    </div>
                )}

                {errorMessage && (
                    <div className="error-message">
                        <p>{errorMessage}</p>
                    </div>
                )}

                {reportId && (
                    reportData?.length === 0 || reportData?.total === 0 ? (
                        <div className="no-results-message-report-screen">
                        <p className='text-no-news-report-screen'>Não há notícias para o período selecionado.</p>
                        </div>
                    ) : (
                        <RelatorioStatusCard reportId={reportId} onVisualizar={handleVisualizarRelatorio} />
                    )
                )}

                {reportId && selectedReport?.value === 1 && shouldShowReport && (
                    <div className="row-pdf-save">
                        <div className="filter-pdf-save">
                            <div className="filter-label-relatorio">Nome do PDF</div>
                            <input
                                type="text"
                                className="filter-select-relatorio keyword-dropdown"
                                placeholder="Digite o nome do PDF"
                                value={pdfName}
                                onChange={(e) => setPdfName(e.target.value)}
                            />
                        </div>
                        <div className="filter-tela-relatorio">
                            <div className="filter-label-relatorio" style={{ visibility: 'hidden' }}>.</div>
                            <button
                                className="buttonGeneratePdfSave"
                                onClick={handleSavePDF}
                                disabled={isSavingPDF || !pdfName}
                            >
                                {isSavingPDF ? 'Salvando...' : 'Salvar PDF'}
                            </button>
                        </div>
                    </div>
                )}

                {reportId && selectedReport?.value === 1 && shouldShowReport && (
                    <div className="filter-tela-relatorio" style={{ margin: '20px 0' }}>
                        <div className="filter-label-relatorio">Páginas</div>
                        <Select
                            className="filter-select-relatorio"
                            styles={customStylesPages}
                            placeholder="Selecione as páginas"
                            isMulti
                            value={selectedPages}
                            onChange={handlePageSelection}
                            options={pageOptions}
                        />
                    </div>
                )}

                {shouldShowReport && reportData && selectedReport && selectedReport.value === 1 && (
                    <>
                        <div className="preview-container">
                            <div className="preview-header">
                                <h2>Relatório gerado:</h2>
                                <button className="download-button" onClick={handleDownloadReport} disabled={isLoadingPDF}>
                                    <><FaDownload /> Download</>
                                </button>
                            </div>
                            <RelatorioAnalitico
                                ref={relatorioAnaliticoRef}
                                reportData={reportData}
                                startDate={startDate}
                                endDate={endDate}
                                selectedPages={selectedPages}
                                isLoadingPDF={isLoadingPDF} 
                                reportFinalImage = {
                                    reportData.images?.report_final_image
                                        ? reportData.images.report_final_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                                            : null
                                }
                                reportInitialimage={
                                    reportData.images?.report_cover_image
                                        ? reportData.images.report_cover_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                                            : `${linkClient}/media/reports/fundo-inicial-relatorio.png`
                                }
                                reportGrapichImage={
                                    reportData.images?.report_charts_image
                                        ? reportData.images.report_charts_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                                            : `${linkClient}/media/reports/fundo-graficos-relatorio.png`
                                }
                                reportInfoImage={
                                    reportData.images?.report_info_image
                                        ? reportData.images.report_info_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                                            : `${linkClient}/media/reports/fundo-informacoes.png`
                                }
                                clientId={clientId}
                                commentsAnalytic={comments}
                            />
                        </div>
                        {downloadSuccessMessage && (
                            <div className="success-message">
                                <p>{downloadSuccessMessage}</p>
                            </div>
                        )}
                    </>
                )}

                {/* {showConfirmModal && (
                    <ConfirmModal
                        title="Confirmação de Limpeza de dados"
                        message="Tem certeza de que deseja limpar os dados antes de gerar o relatório?"
                        onConfirm={handleConfirmClearReport}
                        onCancel={() => setShowConfirmModal(false)}
                    />
                )} */}

                {statisticalReportData && selectedReport && selectedReport.value === 2 && (
                    <div className="preview-container-statistic">
                        <div className="preview-header">
                            <h2>Relatório Estatístico Gerado:</h2>
                            <button className="download-button" onClick={() => document.getElementById("relatorio-estatistico").querySelector("button").click()} disabled={isLoadingPDF}>
                                <FaDownload /> Download
                            </button>
                        </div>
                        <ReportStatistic startDate={startDateStatistical} endDate={endDateStatistical} clientId={clientId} data={statisticalReportData} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default TelaRelatorio;
